import React from 'react';
import { Box } from '@mui/material';

export default function StudyIndexBadge({ index, size = 'small' }) {
  const dimension = size === 'small' ? 20 : 24;
  const fontSize = size === 'small' ? '0.7rem' : '0.75rem';

  return (
    <Box
      component="span"
      sx={{
        display: 'inline-flex',
        alignItems: 'center',
        justifyContent: 'center',
        minWidth: dimension,
        height: dimension,
        px: 0.25,
        borderRadius: '50%',
        backgroundColor: 'color-mix(in srgb, var(--rd-primary) 15%, transparent)',
        color: 'var(--rd-primary)',
        fontWeight: 700,
        fontSize,
        lineHeight: 1,
        flexShrink: 0,
      }}
    >
      {index}
    </Box>
  );
}
